export const UPSC_SEO_CONFIG_CMS_API_PATH = 'upsc-seo-config';

export const UPSC_SEO_PAGE_CONFIG_KEYS = [
  'homeSeo',
  'todayAnalysisSeo',
  'quizSeo',
  'calendarSeo',
  'monthlyPdfSeo',
  'dailyPdfSeo',
  'monthlyClassesSeo',
  'subjectWiseSeo',
  'detailPageSeo'
];

const normalizeSeoPageConfig = (item) => {
  if (!item || typeof item !== 'object') {
    return undefined;
  }

  const metaTitle = (item.metaTitle || '').trim();
  const metaDescription = (item.metaDescription || '').trim();
  const robotsMeta = (item.robotsMeta || 'index, follow').trim();
  const { structuredData } = item;

  if (!metaTitle && !metaDescription && !structuredData) {
    return undefined;
  }

  return {
    id: item.id,
    pageName: (item.pageName || '').trim(),
    metaTitle,
    metaDescription,
    robotsMeta,
    structuredData
  };
};

export const normalizeUpscSeoConfigResponse = (data) => {
  if (!data || typeof data !== 'object') {
    return {};
  }

  return UPSC_SEO_PAGE_CONFIG_KEYS.reduce((normalized, configKey) => {
    const pageSeo = normalizeSeoPageConfig(data[configKey]);

    if (!pageSeo) {
      return normalized;
    }

    return {
      ...normalized,
      [configKey]: pageSeo
    };
  }, {});
};
